import { ApplicationInsights } from "@microsoft/applicationinsights-web";

export function initAppInsights() {
  const connectionString = process.env.REACT_APP_APPINSIGHTS_CONNECTION_STRING;
  if (!connectionString || !connectionString.trim()) {
    return null;
  }

  try {
    const appInsights = new ApplicationInsights({
      config: {
        connectionString,
        enableAutoRouteTracking: false,
        disableExceptionTracking: false,
      },
    });
    appInsights.loadAppInsights();
    appInsights.trackPageView();
    return appInsights;
  } catch (err) {
    console.error("App Insights init failed", err);
    return null;
  }
}
